
import { useState } from 'react';

const InfoButton = ({ value, toggle }) => {
  const [isVisible, setIsVisible] = useState(false); // State to track visibility of section

  const handleClick = () => {
    setIsVisible(!isVisible); // Toggle visibility state
    toggle(value); // Call toggle function with the value of the button
  };

  return (
    <div>
      <button onClick={handleClick}>{value}</button> {/* Button with click event */}
    </div>
  );
};

export default InfoButton;